// Adaptis: Price dual-range slider + manual inputs (AJAX-safe)
(() => {
  function clamp(n, a, b) {
    return Math.min(Math.max(n, a), b);
  }

  function init(root) {
    if (!root || root.dataset.adaptisPriceInit === "1") return;

    const rangeMax = Number(root.dataset.rangeMax || 0);

    const minRange = root.querySelector("[data-adaptis-min-range]");
    const maxRange = root.querySelector("[data-adaptis-max-range]");
    const rangeFill = root.querySelector("[data-adaptis-range]");

    const minText = root.querySelector("[data-adaptis-min-text]");
    const maxText = root.querySelector("[data-adaptis-max-text]");

    const minInput = root.querySelector('input[ref="minInput"]');
    const maxInput = root.querySelector('input[ref="maxInput"]');

    if (!rangeMax || !minRange || !maxRange || !rangeFill || !minInput || !maxInput) return;

    root.dataset.adaptisPriceInit = "1";

    let commitTimer = null;

    function paint(a, b) {
      // Update range fill between thumbs only
      const left = rangeMax ? (a / rangeMax) * 100 : 0;
      const right = rangeMax ? (b / rangeMax) * 100 : 0;
      rangeFill.style.left = left + "%";
      rangeFill.style.right = (100 - right) + "%";

      // Sync manual inputs if present
      if (minText) minText.value = String(a);
      if (maxText) maxText.value = String(b);
    }

    function setAll(a, b, source = "range") {
      a = clamp(Number(a || 0), 0, rangeMax);
      b = clamp(Number(b || 0), 0, rangeMax);

      if (a > b) {
        const t = a; a = b; b = t;
      }

      // Update sliders
      minRange.value = String(a);
      maxRange.value = String(b);

      // Update hidden facet inputs (real params)
      minInput.value = String(a);
      maxInput.value = String(b);

      paint(a, b);
      return { a, b };
    }

    function commit() {
      // Trigger change so facets component applies filters
      minInput.dispatchEvent(new Event("change", { bubbles: true }));
      maxInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function commitDebounced(ms = 250) {
      window.clearTimeout(commitTimer);
      commitTimer = window.setTimeout(() => {
        commit();
      }, ms);
    }

    // Range -> UI + inputs
    function onRangeInput() {
      setAll(minRange.value, maxRange.value, "range");
    }

    function onRangeChange() {
      setAll(minRange.value, maxRange.value, "range");
      commit();
    }

    minRange.addEventListener("input", onRangeInput);
    maxRange.addEventListener("input", onRangeInput);

    minRange.addEventListener("change", onRangeChange);
    maxRange.addEventListener("change", onRangeChange);

    // Manual input -> sliders + hidden inputs
    function onTextInput() {
      if (!minText || !maxText) return;
      setAll(minText.value, maxText.value, "text");
      // Optional: live-apply while typing (debounced)
      commitDebounced(350);
    }

    function onTextCommit() {
      if (!minText || !maxText) return;
      setAll(minText.value, maxText.value, "text");
      commit();
    }

    if (minText && maxText) {
      minText.addEventListener("input", onTextInput);
      maxText.addEventListener("input", onTextInput);

      // Commit on blur
      minText.addEventListener("blur", onTextCommit);
      maxText.addEventListener("blur", onTextCommit);

      // Commit on Enter
      minText.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onTextCommit();
        }
      });
      maxText.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onTextCommit();
        }
      });
    }

    // If Shopify updates hidden inputs on re-render, repaint UI from them
    function normalizeFromInputs() {
      const a = Number(minInput.value || 0);
      const b = Number(maxInput.value || rangeMax);
      setAll(a, b, "inputs");
    }

    minInput.addEventListener("change", normalizeFromInputs);
    maxInput.addEventListener("change", normalizeFromInputs);

    // Initial paint (important after AJAX render)
    normalizeFromInputs();
  }

  function initAll(context = document) {
    context.querySelectorAll("[data-adaptis-price]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", () => initAll());

  // AJAX-safe: initialize after Shopify replaces facets HTML
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.("[data-adaptis-price]")) init(node);
        node.querySelectorAll?.("[data-adaptis-price]").forEach(init);
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();